//# sourceMappingURL=toc-item.interface.js.map


//////////////////
// WEBPACK FOOTER
// ./~/pdfmake-wrapper/lib/interfaces/toc/toc-item.interface.js
// module id = 1192
// module chunks = 4